module.exports = {
    //1
    EVENT_ATTENDEE_IMT_NTF:{
        type:'ATTENDEEIMP',
    },
    EVENT_ATTENDEE_EXP_NTF:{
        type:'ATTENDEEEXP',
    },
    EVENT_ATTENDEE_QRCODE_EXT_NTF:{
        type:'QRCODEEXP',
    },
    EVENT_ATTENDEE_INFO_QRCODE_EXT_NTF:{
        type:'ATTENDEE_INFO_QRCODEEXP',
    },
    EVENT_PRICE_DRAW_EXP_NTF:{
        type:'DRAW_WINNERS_EXP',
    },
    EVENT_PRICE_ROLL_EXP_NTF:{
        type:'ROLL_WINNERS_EXP',
    },
    EVENT_ALLOT_EXP_NTF:{
        type:'ALLOT_IMP',
    }

    ,
    EVENT_ATTENDEE_CHECKIN_COUNT_EXT_NTF:{
        type:'DAY_CHECKIN_COUNT_EXP',
    },
    EVENT_REPORT_TAIL_SINGIN_EXP_NTF:{
        type:'TAIL_SIGNIN_REPORT_EXP',
    },
    EVENT_ATTENDEE_COLLECT_COUNT_EXT_NTF:{
        type:'ATTENDEE_COLLECT_COUNT_EXP',
    },
    EVENT_INVITEE_IMT_NTF:{
        type:'INVITATIONIMP',
    },
    EVENT_INVITEE_EXP_NTF:{
        type:'INVITATIONEXP',
    },
    USER_CONTACT_IMP_NTF:{
        type:'CONTACTIMP',
    },
    SURVEY_EXP_NTF:{
        type:'SURVEY_EXP',
    },
    VOTE_EXP_NTF:{
        type:'VOTE_EXP',
    },
    LUCKYMONEY_EXP_NTF:{
      type:'LUCKYMONEY_EXP',
    },
    EVENT_ATTENDEE_BADGE_EXT_NTF:{
      type:'ATTENDEEBADGEEXP',
    },
    REWARD_DETAIL_EXP_NTF:{
        type:'REWARD_DETAIL_EXP',
    },
    MARKET_PURCHASE_EXP_NTF:{
        type:'MARKET_PURCHASE_EXP',
    },
    GUESS_PLAYER_EXP_NTF:{
        type:'GUESS_PLAYER_EXP',
    },
    EVENT_ORDER_EXP_NTF:{
        type:'EVENT_ORDER_EXP',
    },
    EVENT_ATTENDEE_PIC_NTF:{
        type:'ATTENDEE_PIC_EXP',
    },
    EVENT_ATTENDEE_FILE_NTF:{
        type:'ATTENDEE_FILE_EXP',
    },
    EVENT_ATTENDEE_FROM_CONTACT_IMT_NTF:{
        type:'ATTENDEE_CONTACT_IMP',
    },
    EVENT_ATTENDEE_INVOICE_EXT_NTF:{
        type:'ATTENDEE_INVOICE_EXP',
    },
    EVENT_LEVEL_SHARE_EXP_NTF:{
        type:'LEVEL_SHARE_EXP',
    },
    EVENT_PDF_DIPLOMA_EXT_NTF:{
        type:'PDF_DIPLOMA_EXP',
    },
    EVENT_CODE_SHARE_EXP_NTF:{
        type:'EVENT_CODE_SHARE_EXP',
    },
    EVENT_WJW_MAKE_EXP_NTF:{
        type:'WJW_MAKE_EXP',
    },
    EVENT_CHECKIN_CREDIT_EXP_NTF:{
        type:'CHECKIN_CREDIT_EXP',
    },
    GUEST_GROUP_EXP_NTF:{
        type:'GUEST_GROUP_EXP',
    },
    LEAP_EVENT_EXP_NTF:{
        type:'LEAP_EVENT_EXP',
    },
    EVENT_CHECKIN_LOG_EXP_NTF:{
        type:'CHECKIN_LOG_EXP',
    },


}


// WEBPACK FOOTER //
// ./src/utils/taskType.js